//
const waitUntil         = require('./waitUntil.js');
const createElement     = require('./createElement.js');
const debounce          = require('./debounce');

//load the external editor javascript if needed, and run the supplied callback once loaded
module.exports.loadEditor = async function () {

    //if the ckeditor global is already defined, then the loading has been complete so we can call the callback immediatly
    if (typeof CKEDITOR !== 'undefined') {
        return;
    }

    //start loading the ckeditor script
    const editorScript = createElement('script', { 'src' : '/js/thirdparty/ckeditor/ckeditor.js' });
    document.querySelector('head').append(editorScript);

    //
    await waitUntil(() => {
        return (typeof CKEDITOR !== 'undefined');
    }, 100)

};

//==============================================================================

//define a "simple" editor config
module.exports.createSimpleContentEditor = async function (element) {

    //
    await this.loadEditor();

    //
    const editor = CKEDITOR.replace(element.id, {
        toolbar: [
            { items: ['Undo', 'Redo'] },
            { items: ['Bold', 'Italic', 'Underline','-', 'Subscript', 'Superscript', '-', 'NumberedList', 'BulletedList'] }
        ],
    });

    //apply custom css for the editor
    editor.config.contentsCss = '/css/ckeditor.min.css';

    //make smaller, remove bottom bar, reduce padding - can i make this use an iline editor
    editor.config.removePlugins = 'elementspath';
    editor.config.resize_enabled = false;

    //have the editor update the source element on each change (debounced)
    editor.on('change', debounce(200, function() {
        editor.updateElement();
    }));

    //
    return editor;

};

//==============================================================================

//define a "full" editor config
module.exports.createFullContentEditor = async function (element) {

    //
    await this.loadEditor();

    //
    const editor = CKEDITOR.replace(element.id, {
        toolbar: [
            { items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
            { items: ['Link', 'Unlink', '-', 'Table', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent'] },
            { items: ['Maximize'] },
        ],
    });

    //
    editor.config.resize_enabled = false;

    //have the editor update the source element on each change (debounced)
    editor.on('change', debounce(200, function() {
        editor.updateElement();
    }));

    //
    return editor;

};

//==============================================================================

//define a "custom" editor config
module.exports.createCustomContentEditor = async function (element, buttons) {

    //
    await this.loadEditor();

    //set the editor up with the custom buttons
    const editor = CKEDITOR.replace(element.id, { 'toolbar' : buttons });

    //remove the "path" at the bottom of the editor
    editor.config.removePlugins = 'elementspath';

    //do not allow the user to resize the editor
    editor.config.resize_enabled = false;

    //have the editor update the source element on each change (debounced)
    editor.on('change', debounce(200, function() {
        editor.updateElement();
    }));

    //
    return editor;

};

//==============================================================================